import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionHistoryListItemProps } from '..';
import { HintButton } from '../../../../../../../components/HintButton';
import { TableContentItemStatus } from '../../../../../../../components/TableContent/status';
import { getValidatedStatusIcon } from '../../../../../../../utils/getValidatedStatusIcon';
import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';

export const SubscriptionHistoryListItemMobile: React.FC<SubscriptionHistoryListItemProps> = ({
  historyItem,
  isDisabled,
  disabledMessage,
  onCancel,
}) => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack justifyContent="space-between" space="stack.xxxs">
          <VStack space="stack.quarck">
            <UI.Text variant="semibold" color="neutral.medium" fontSize={Typography['fontsize.xs']}>
              Cliente
            </UI.Text>
            <UI.Text color="neutral.darkest" variant="semibold">
              {historyItem.customerNameNormalized}
            </UI.Text>
          </VStack>
          <HStack justifyContent="space-between" space="inline.nano">
            <VStack w="3/5">
              <UI.Text>Assessor</UI.Text>
              <UI.Text color="neutral.darkest">{historyItem.advisorNameNormalized}</UI.Text>
            </VStack>
            <VStack w="2/6">
              <UI.Text>Qtde. Solicitada</UI.Text>
              <UI.Text color="neutral.darkest">{`${historyItem.requestedQuantity}`}</UI.Text>
            </VStack>
          </HStack>
          <HStack justifyContent="space-between" space="inline.nano">
            <VStack w="3/5">
              <UI.Text>Valor</UI.Text>
              <UI.Text color="neutral.darkest">{historyItem.totalValueFormatted}</UI.Text>
            </VStack>
            <VStack w="2/6">
              <UI.Text>Status</UI.Text>
              <TableContentItemStatus
                basketAdvisorStatus={{
                  isActive: true,
                  statusId: 1,
                  statusIcon: getValidatedStatusIcon(historyItem.status),
                  statusAlias: historyItem.statusAlias,
                }}
              />
            </VStack>
          </HStack>
          <HintButton
            tooltip={disabledMessage}
            variant="textLink"
            isDisabled={isDisabled}
            _text={{
              color: 'feedback.error.default',
              fontFamily: Typography['fontfamily.base.semibold'],
            }}
            onPress={onCancel}
            rightIcon={<UI.Icon name="Trash" size="xxxs" color="feedback.error.default" />}>
            CANCELAR
          </HintButton>
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
